export default __webpack_public_path__ + "static/media/close-popup.89ad5dff.svg";